import React, { useState } from 'react';
import { Dialog, DialogTitle, Button } from '@mui/material';
import {
	useNotify,
	SimpleForm,
	ReferenceInput,
	AutocompleteInput,
	Toolbar,
	SaveButton,
	required,
} from 'react-admin';
import { addBetaTester } from '../../Services/betaRequests';

interface BetaTesterModalCreateProps {
	sku: string;
	open: boolean;
	handleClose: () => void;
	// Appelé après un ajout réussi pour rafraîchir la liste du panneau parent.
	onAdded: () => void;
}

// BetaTesterModalCreate : ajout manuel d'un beta-testeur par un admin (flux push).
// On réutilise la resource react-admin `users` (api-core) pour la recherche live ;
// on ne poste que l'ID numérique, le backend résout Firebase UID + email/nom.
const BetaTesterModalCreate: React.FC<BetaTesterModalCreateProps> = ({
	sku,
	open,
	handleClose,
	onAdded,
}) => {
	const notify = useNotify();
	const [saving, setSaving] = useState(false);

	const handleSave = async (data: any) => {
		setSaving(true);
		try {
			await addBetaTester(sku, data.userId);
			notify('Accès beta accordé', { type: 'success' });
			onAdded();
			handleClose();
		} catch (err: any) {
			notify(`Erreur: ${err?.message || 'unknown'}`, { type: 'error' });
		} finally {
			setSaving(false);
		}
	};

	return (
		<Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
			<DialogTitle>Ajouter un beta-testeur</DialogTitle>
			<SimpleForm
				onSubmit={handleSave}
				toolbar={
					<Toolbar style={{ justifyContent: 'space-between' }}>
						<SaveButton label="Accorder l'accès" disabled={saving} />
						<Button onClick={handleClose} color="secondary">
							Annuler
						</Button>
					</Toolbar>
				}
			>
				<ReferenceInput
					label="Utilisateur"
					source="userId"
					reference="users"
					perPage={25}
					filterToQuery={(searchText: string) => ({ q: searchText })}
				>
					<AutocompleteInput
						label="Utilisateur"
						optionText={(u: any) =>
							u ? `${u.name || '—'} — ${u.email}` : ''
						}
						// Filtrage côté serveur (filterToQuery) : on accepte toute
						// suggestion renvoyée par l'API sans re-filtrer côté client.
						matchSuggestion={() => true}
						validate={required()}
					/>
				</ReferenceInput>
			</SimpleForm>
		</Dialog>
	);
};

export default BetaTesterModalCreate;
